import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Container } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import UserMessageModal from "../modals/UserMessageModal";
import SendMessageModal from "../modals/SendMessageModal";
import UserSelection from "../components/UserSelection";
import DropDownFetchCount from "../components/DropDownFetchCount";
import MessageTypeSelection from "../components/MessageTypeSelection";
import { PageTitleController } from "../components/PageTitleController";
import { BsSendFill } from "react-icons/bs";
import { MessageTable } from "../components/MessageTable";

const UserMessages = () => {
  const { authAxios } = useAuth();
  const [fetchCount, setFetchCount] = useState(25);
  const [type, setType] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [messageData, setMessageData] = useState(null);
  const [user, setUser] = useState(null);
  const [showSendMessage, setShowSendMessage] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    document.title = "Messages";
  }, []);

  const toggleRefresh = () => {
    setRefresh(!refresh);
  };

  return (
    <div>
      <Row>
        <PageTitleController
          title={"Messages"}
          icon={<BsSendFill className={"icon-right-spacing"} />}
        />
        <Col>
          <Row xs={"auto"} className={"justify-content-end"}>
            <Button variant="offblack" onClick={() => setShowSendMessage(true)}>
              + New Message
            </Button>
          </Row>
        </Col>
      </Row>

      <Container fluid className={"p-0 m-0"}>
        <Row xs={"auto"} className={"align-items-center g-3"}>
          <Col xs={"auto"}>
            <UserSelection onSelected={setUser} />
          </Col>
          <Col xs={"auto"}>
            <MessageTypeSelection 
              onSelected={setType} 
              placeholderText="Select Message Type"
            />
          </Col>
          <Col xs={"auto"}>
            <DropDownFetchCount
              onSelected={setFetchCount}
              defaultSelection={fetchCount}
            />
          </Col>
        </Row>
      </Container>

      <br />

      <MessageTable
        selectedUser={user}
        refresh={refresh}
        selectedFetchCount={fetchCount}
        selectedType={type}
      />

      <UserMessageModal
        visible={showMessage}
        close={() => setShowMessage(false)}
        message={messageData}
      />
      <SendMessageModal
        visible={showSendMessage}
        close={() => setShowSendMessage(false)}
        refresh={toggleRefresh}
      />
    </div>
  );
};

export default UserMessages;
